'use client'

import styled, { css } from 'styled-components'

import { untilMd } from '@syconium/little-miss-figgy'

export const Container = styled.div<{ leftOffset?: boolean; topOffset?: boolean }>`
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-start;
  margin-inline-start: ${o => (o.leftOffset ? 0 : '-8px')};
  margin-top: ${o => (o.topOffset ? '8px' : 0)};
  gap: ${o => o.theme.spacing(2)};
`

export const BadgeWrapper = styled.div<{ isFinalSale?: boolean }>`
  margin: ${o => o.theme.spacing(4, 0, 0, 0)};
  ${untilMd} {
    margin: ${o => o.theme.spacing(0)};
  }
  ${({ isFinalSale }) =>
    isFinalSale &&
    css`
      margin: 0;
    `}
`
